import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

import './ChecklistTaskSponsoredContent.less';

const ChecklistTaskSponsoredContent = ({ url, urlText, isSponsoredLinkFromZola }) => {
  const renderSponsoredContent = () => (
    <div className="checklist__sponsored--container">
      <span className="checklist__sponsored--icon checklist__checklist--icon" aria-hidden="true" />
      <h2 className="checklist__sponsored--header">Want help with this task?</h2>
      <div className="checklist__sponsoredDescription--container">
        <span className="checklist__sponsored--description">We may earn compensation if you hit the button below.</span>
        <span className="checklist__sponsored--arrow hidden-xs hidden-sm" aria-hidden="true" />
      </div>
      <ButtonV2 component="a" role="link" href={url} className="checklist__sponsored--CTA">
        {urlText}
      </ButtonV2>
    </div>
  );

  const renderZolaContent = () => (
    <div className="checklist__sponsored--container isFromZola">
      <span className="checklist__sponsored--icon checklist__zolaLogo--icon" aria-hidden="true" />
      <h2 className="checklist__sponsored--header">
        Check this off <br className="visible-md visible-lg" />
        the easy way!
      </h2>
      <ButtonV2 component="a" role="link" href={url} className="checklist__sponsored--CTA checklist__zola--CTA">
        {urlText}
      </ButtonV2>
    </div>
  );

  return isSponsoredLinkFromZola ? renderZolaContent() : renderSponsoredContent();
};

ChecklistTaskSponsoredContent.propTypes = {
  url: PropTypes.string,
  urlText: PropTypes.string,
  isSponsoredLinkFromZola: PropTypes.bool,
};

ChecklistTaskSponsoredContent.defaultProps = {
  isSponsoredLinkFromZola: false,
};

export default ChecklistTaskSponsoredContent;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTaskSponsoredContent/ChecklistTaskSponsoredContent.jsx